import * as yup from 'yup';
import i18n from 'i18n-js';

const EditGroupValidationSchema = () =>
    yup.object().shape({
        name: yup
            .string()
            .max(128)
            .required(
                i18n.t('form.errors.required', {
                    name: 'Name',
                })
            ),
        selectedRestaurants: yup
            .array()
            .min(2, i18n.t('form.errors.minItems', { count: 2 }))
            .required(
                i18n.t('form.errors.required', {
                    name: 'Selected Restaurants',
                })
            ),
        selectedUsers: yup
            .array()
            .min(1, i18n.t('form.errors.minItems', { count: 1 }))
            .required(
                i18n.t('form.errors.required', {
                    name: 'Selected Users',
                })
            )
    });

export default EditGroupValidationSchema;
